// extracted by mini-css-extract-plugin
export default {"switch":"PickUpPointSwitch_switch__1ATsV"};